import { render, staticRenderFns } from "./FormularioAddVacuna.vue?vue&type=template&id=388a60db&scoped=true"
import script from "./FormularioAddVacuna.vue?vue&type=script&lang=js"
export * from "./FormularioAddVacuna.vue?vue&type=script&lang=js"
import style0 from "./FormularioAddVacuna.vue?vue&type=style&index=0&id=388a60db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a60db",
  null
  
)

export default component.exports